<template>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
    class="demo-ruleForm login-container">
    <h3 class="title">密码修改</h3>
    <el-form-item prop="oldCode">
      <el-input type="text" v-model="ruleForm2.oldCode" auto-complete="off" placeholder="输入旧密码"></el-input>
    </el-form-item>
    <el-form-item prop="newCode">
      <el-input type="text" v-model="ruleForm2.newCode" auto-complete="off" placeholder="输入新密码"></el-input>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">提交修改
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          // oldCode: 'justin',
          // newCode: '123456'
        },
        rules2: {
          oldCode: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          newCode: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    mounted(){
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          lett.handleSubmit2();
        }
}
    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate(async (valid) => {
          if (valid) {
            this.logining = true;
            var para = {oldPassword : this.ruleForm2.oldCode, newPassword: this.ruleForm2.newCode };
            
            let url =`/user/password/change`
            let result = await this.$http.post(this,url,para ,null,(cancel)=>{this.cancel = cancel});
            console.log('---',result)
            this.logining = false;
            if (result&&result.data) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(()=>{
               _this.$router.push("/login");
              }, 500)
            } else {
              this.$message({
                message: '修改失败:'+result.message,
                type: 'error'
              });
            }
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>